import { createSlice, isFulfilled, isPending, isRejected, PayloadAction } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { PartnersListState, PARTNERS_LIST_SLICE_NAME, initialState } from './models';
import {
  getPartnerDetails,
  updatePartnerDetails,
  createPartner,
  getPartnersList,
  deletePartner,
  hidePartner,
  togglePartnerActive,
} from './actionCreators';
import { TGetPartnerQuery } from '../helpers/types';

export const slice = createSlice({
  name: PARTNERS_LIST_SLICE_NAME,
  initialState,
  reducers: {
    resetPartnersListState() {
      return { ...initialState };
    },
    changeQuery: (state: PartnersListState, action: PayloadAction<TGetPartnerQuery>) => {
      state.query = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPartnerDetails.fulfilled, (state: PartnersListState, action) => {
        state.partnerDetails = action.payload;
        state.isLoading = false;
      })
      .addCase(getPartnersList.fulfilled, (state: PartnersListState, action) => {
        state.partnersList = action.payload;
        state.isLoading = false;
      })
      .addCase(deletePartner.fulfilled, (state: PartnersListState) => {
        state.isLoading = false;
      })
      .addCase(hidePartner.fulfilled, (state: PartnersListState) => {
        state.isLoading = false;
      })
      .addCase(togglePartnerActive.fulfilled, (state: PartnersListState) => {
        state.isLoading = false;
      })
      .addMatcher(
        isPending(updatePartnerDetails, createPartner, deletePartner, hidePartner, togglePartnerActive),
        (state: PartnersListState) => {
          state.isLoading = true;
          state.error = null;
        },
      )
      .addMatcher(isFulfilled(updatePartnerDetails, createPartner), (state: PartnersListState, action) => {
        state.partnerDetails = action.payload;
        state.isLoading = false;
      })
      .addMatcher(
        isRejected(updatePartnerDetails, createPartner, deletePartner, hidePartner, togglePartnerActive),
        (state: PartnersListState, action) => {
          const { error } = action;
          state.isLoading = false;
          state.error = error;

          showApiErrors(error);
        },
      );
  },
});

export const { resetPartnersListState, changeQuery } = slice.actions;

export default slice.reducer;
